import { ENABLE_SORTING } from './actionType';

export const toggleSorting = (isOn) => dispatch => {
  dispatch({ type: ENABLE_SORTING, payload: { isOn } });
};
